<template>
  <div class="home_doctor" data-testid="doctor-dashboard">
    <div class="row justify-content-md-center">
      <div class="col-md-8">
        <visits></visits>
      </div>
      <div class="col-md-4">
        <tasks></tasks>
      </div>
      <!--
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6">
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
  import Visits from './components/Visits.vue'
  import Tasks from './components/Tasks.vue'

  export default {
    data () {
      return {
        //
      }
    },
    components: {
      Visits,
      Tasks
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/HomeDoctor/HomeDoctor.vue?6087c7cf